import { createContext, useContext, useState } from "react";

const SalonContext = createContext();
export  function SalonContextProvider({ children }) {
    
    const [salon,setsalon] = useState(null)

    return (
        <SalonContext.Provider value={{salon,setsalon}}>
            {children}
        </SalonContext.Provider>
    );
}

export function useSalon() {
    return useContext(SalonContext);
}